/**
 * Texts for Sam's review article
 */
export const samReviewText = {
    title: 'Sam and Sofia-Stevie - CamAPS FX',
    titleMeta: 'Read review of CamAPS FX by Sam and Sofia-Stevie',
    descriptionMeta: 'CamAPS FX has been life changing for Sam and Sofia-Stevie allowing ' +
        'Sam to relax for the first time since the diagnosis.',
    keywords:
        'camaps review Sam and Sofia-Stevie, camaps fx review Sam and Sofia-Stevie, ' +
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ' +
        '',
    localeMeta: 'en_gb',

    imageTitle: 'Sam and Sofia-Stevie',
    shortIntroAndBody:
        '<h2>I feel that for the first time since the diagnosis I can relax</h2>' +
        '<p>' +
        '        I have full trust in the CamAPS FX app and I feel like for ' +
        '        the first time since the diagnosis I can relax. Without a doubt, the ' +
        '        time Sofia-Stevie spends within her target blood glucose range has ' +
        '        improved. ' +
        '</p>',
    body: 
        '<h2>I feel that for the first time since the diagnosis I can relax</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '        Over the past two years Sam, mother to Sofia-Stevie (aged 5), ' +
        '        has endured the tremendously steep learning curve any parent of a child ' +
        '        with type 1 diabetes has to undergo. A whirlwind of finger prick tests, ' +
        '        injections and sensors later, she has now discovered the CamAPS FX app ' +
        '        and the hybrid closed-loop system and would not be without it. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    In a hot summer excessive thirst wouldn’t be anything out of the ordinary ' +
        '    for a young child. However, Sam and her mum followed their intuition ' +
        '    that it could be something more and began to research if there was any cause ' +
        '    for concern, which ultimately led to Sofia-Stevie’s diagnosis of ' +
        '    type 1 diabetes. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “The diagnosis changed everything forever, I can remember the first few ' +
        '        weeks like it was yesterday. Almost overnight I felt like I needed ' +
        '        to be an expert in diabetes to best care for my little girl. ' +
        '        She is my absolute priority, so I just did it, and I feel really proud ' +
        '        of myself and my mum for doing it – she’s been on this journey ' +
        '        with us from the beginning.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    A steep learning curve ' +
        '</h3> ' +
        '<p> ' +
        '    Like most parents with a newly diagnosed child with type 1 diabetes ' +
        '    Sam quickly became an expert at finger prick tests, basal and bolus ' +
        '    insulin dosing and what to do when her daughter was hypoglycaemic. ' +
        '    Injecting your child would be a challenge for any parent, but particularly ' +
        '    for Sam as she also had to overcome a fear of needles. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “The clinical team at Addenbrooke’s Hospital were amazing at ' +
        '        helping me overcome some big challenges in those early days, ' +
        '        especially Adam Dawes, Clinical Nurse Specialist at the hospital. ' +
        '        I don’t think we’d be where we are today without the support of ' +
        '        Adam and the clinical team.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    In the first few months of Sofia-Stevie’s diagnosis finger prick tests were ' +
        '    a ' +
        '    regular occurrence to understand blood glucose levels through the day. ' +
        '    Sam also had to set alarms at night so she could check her daughter’s blood ' +
        '    glucose levels. If Sofia-Stevie’s levels were high or low, Sam would have to ' +
        '    administer a corrective dose and then wait until her levels were moving in ' +
        '    the right direction before going back to sleep, an exhausting process ' +
        '    for both every single night. ' +
        '</p> ' +
        '<p> ' +
        '    Eventually Sofia-Stevie received a continuous glucose monitor (CGM) to ' +
        '    support her care. A CGM is a small device with a sensor worn just under ' +
        '    the skin to measure glucose levels continuously. Sam saw the CGM as a step ' +
        '    in the right direction, particularly as the device meant she no longer had ' +
        '    to set alarms at night – the device would alert her if Sofia-Stevie’s ' +
        '    glucose levels were out of range automatically. The CGM also syncs with ' +
        '    Sam’s phone so she can check Sofia-Stevie’s blood glucose levels at ' +
        '    school and it also helps teachers with care through the day. ' +
        '</p> ' +
        '<p> ' +
        '    But in January 2020 Sam was introduced to the CamAPS FX app ' +
        '    and hasn’t looked back since. ' +
        '</p> ' +
        '<h3> ' +
        '    Finding freedom ' +
        '</h3> ' +
        '<p> ' +
        '    The CamAPS FX app was developed to mimic the key functions of a ' +
        '    healthy pancreas, a so-called hybrid closed-loop approach to treatment. ' +
        '    The app communicates autonomously with a patient’s CGM and insulin pump ' +
        '    and uses a complex algorithm to automatically calculate and administer ' +
        '    the optimal dose of insulin every 8-12 minutes. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “I’d never heard of the hybrid closed-loop system, ' +
        '        or the CamAPS FX app before. I didn’t know how it worked but when ' +
        '        Adam suggested it might be a benefit to us we jumped in with both feet. ' +
        '        At that point I’d learnt so much about diabetes, learning about the ' +
        '        hybrid closed-loop felt like a walk in the park.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “I have full trust in the CamAPS FX app and I feel like for ' +
        '        the first time since the diagnosis I can relax. Without a doubt, the ' +
        '        time Sofia-Stevie spends within her target blood glucose range has ' +
        '        improved. It is so much easier to control her levels now and is a ' +
        '        complete weight off my shoulders. It is also less of a burden for ' +
        '        her teachers and much less worry for me. I can check on her ' +
        '        remotely if I want to but also have the reassurance of receiving ' +
        '        automated text messages if she’s going high or low.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “You wouldn’t know that she is any different from any of her ' +
        '        classmates and that is thanks to the CamAPS FX app.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    Sam isn’t alone in her observations about the change the CamAPS FX app has ' +
        '    had on her and her daughter. Research has shown that the app improves ' +
        '    adolescents’ sleep and provides a sense of waking up feeling normal, ' +
        '    which facilitates improved diabetes control during the day, aiding ' +
        '    concentration and well-being in school. In addition, parents of children ' +
        '    using the app have been shown to feel less anxious about their child’s ' +
        '    diabetes, and as a result better able to give their children greater ' +
        '    freedom, like being able to play with friends, go on school trips and ' +
        '    attend sleepovers. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “It makes so much sense for children of Sofia-Stevie’s age to have ' +
        '        the closed-loop, because their bodies are constantly changing how ' +
        '        they respond to insulin. It is an extremely difficult ask for a ' +
        '        parent to keep on top of that without significant highs and lows, ' +
        '        whereas the app learns and adapts instantly. It is beneficial for ' +
        '        the child’s long-term management of the condition and freedom for ' +
        '        the parents so they can sleep at night.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    I would never be without the app ' +
        '</h3> ' +
        '<p> ' +
        '    <i> ' +
        '        “I would never be without the app. It is something looking out for ' +
        '        you so you don’t have to worry. To anyone considering it, just go for ' +
        '        it. ' +
        '        It is a game changer and you won’t look back or want to be without ' +
        '        it once you’ve had it. I completely believe it is so beneficial for ' +
        '        both the parents and the child.” ' +
        '    </i> ' +
        '</p>'

};

/**
 * Texts for Roger's review article
 */
export const rogerReviewText = {
    title: 'Roger - CamAPS FX',
    titleMeta: 'Read review of CamAPS FX by Roger',
    descriptionMeta: 'Roger comments that CamAPS FX can be used by anyone and at any age.',
    keywords:
        'camaps review Roger, camaps fx review Roger, ' +
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ' +
        '',
    localeMeta: 'en_gb',

    imageTitle: 'Roger',
    shortIntroAndBody:
        '<h2>If I can do it, anyone can</h2>' +
        '<p>' +
        '    It is amazing how much treatment has changed since I was diagnosed. ' +
        '    I really feel like I’ve come from the desert into the digital world. ' +
        '    To anyone considering the CamAPS FX app, my advice is quite simple: go for it. ' +
        '    It really is transformational; and if I can do it, anyone can.' +
        '</p>',
    body:
        '<h2>If I can do it, anyone can</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '        Diagnosed with type 1 diabetes as an adult, retired headteacher Roger, ' +
        '       aged 69, has spent the last 39 years in pursuit of a greater understanding of ' +
        '       his condition. He has experienced first-hand the transformation in diabetes care ' +
        '       during this time, from glass syringes and thick needles sterilised in a saucepan of ' +
        '       boiling water to the CamAPS FX app and the hybrid closed-loop system, ' +
        '       which he now would not be without.   ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Today type 1 diabetes is often diagnosed in childhood, but for Roger it wasn’t until ' +
        '   he was 30 that his symptoms became apparent. Both Roger’s uncle and mother-in-law had ' +
        '   been diagnosed with type 1 diabetes previously, so he was already familiar with the symptoms. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “I remember vividly I’d just had my breakfast and was out in the garden doing a ' +
        '       few jobs. I came back inside and was extremely thirsty. I downed a pint of ' +
        '       squash in one go and my wife and I looked at each other and at the same ' +
        '       time said ‘diabetes’. My GP took some convincing, but I was referred for tests ' +
        '       and they confirmed I was diabetic.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “At the time knowledge and treatment of diabetes was very limited compared to now. ' +
        '           I was simply given some glass syringes, told how to sterilise the needles in ' +
        '           boiling water with a saucepan and given a target amount of insulin. ' +
        '           Fortunately, my mother-in-law lent me her British Diabetic Association handbook and ' +
        '           I can remember sitting in our kitchen with my wife holding open the pages of the ' +
        '           book while I taught myself how to do the injections.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Pursuing better control  ' +
        '</h3> ' +
        '<p> ' +
        '    During these initial years Roger benefitted greatly from the British Diabetic ' +
        '   Association’s (now known as Diabetes UK) resources, for example learning about the need to ' +
        '   administer more insulin when he was ill which he hadn’t previously been aware of. ' +
        '   Roger was managing his condition well but then his glucose levels became more challenging ' +
        '   and so he was referred onto the DAFNE (dose adjustment for normal eating) course to learn ' +
        '   about matching his insulin to his diet and lifestyle. However, Roger was still experiencing ' +
        '   severe hypoglycaemic events.  ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “I was looking after my Grandson and playing football with him in the garden. ' +
        '       My son-in-law came to pick him up and suddenly said, ‘Roger you need to go get ' +
        '       yourself a juice.’ Sure enough, I did a finger prick test and was at about 2 mmol/l, ' +
        '       so well below where it should be. I was meant to be looking after my Grandson ' +
        '       the following day but they made other arrangements. They didn’t think I was well ' +
        '       enough to look after him and that devastated me and I knew enough was enough.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    After sharing this story with Roger’s consultant, he was referred onto a ' +
        '      research project investigating unexplained hypoglycaemic events and was started on ' +
        '       an insulin pump. Immediately the pump helped improve Roger’s glucose levels. ' +
        '</p> ' +
        '<p> ' +
        '    Having benefitted so much from the first research project, when Roger was offered a ' +
        '   chance to take part in another research project he jumped at the chance and started on ' +
        '   the CamAPS FX app in October 2019. ' +
        '</p> ' +
        '<p> ' +
        '    The CamAPS FX app was developed to mimic the key functions of a healthy pancreas, ' +
        '       a so-called hybrid closed-loop approach to treatment. The app communicates autonomously ' +
        '       with a patient’s continuous glucose monitor and insulin pump and uses a complex algorithm ' +
        '       to automatically calculate and administer the optimal dose of insulin every 8-12 minutes.   ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Admittedly I hadn’t heard of the hybrid closed-loop system before, ' +
        '       but when my two children heard I’d be managing my diabetes from a smartphone ' +
        '       they laughed their heads off! Prior to the research the extent of my knowledge of ' +
        '       using a phone was switching it on, making a call and switching it back off, but ' +
        '       actually with some support from the very knowledgeable clinical team at Addenbrooke’s ' +
        '       Hospital I got on really quite well with the smartphone and the CamAPS FX app. ' +
        '       Its ability to just control and treat your diabetes is just tremendous and very liberating.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Complete discretion ' +
        '</h3> ' +
        '<p> ' +
        '    Since starting on the CamAPS FX app Roger has reduced his bolus ' +
        '   insulin and seen a reduction in the amount of insulin required each day. ' +
        '   But Roger has seen other benefits too.  ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Now when we go out for meals all I need do is take out my smartphone, ' +
        '       enter the carbohydrate count and away it goes. I can see my levels instantly ' +
        '       and can do everything I need to do on the phone. Before I had the app I needed to ' +
        '       carry around with me needles and insulin and would go to the toilets to do a finger ' +
        '       prick test and injections as needed. That’s all taken care of now with complete discretion.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Another time we benefitted from the app was at the beginning of the COVID-19 pandemic ' +
        '       when I’d taken a real bad turn. I was thinking the worst, but the app was providing a ' +
        '       continuous reading of my blood glucose levels which was a great reassurance. At one point ' +
        '       I fell asleep and my wife was worried I may be going into a diabetic coma, but she ' +
        '       quietly checked my blood glucose levels on my phone while I slept and could see all was well. ' +
        '       The app provides peace of mind which is a benefit both to mine and my wife’s quality of life.”' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '        The feeling of reassurance and discretion isn’t something that just ' +
        '       Roger and his wife have experienced. Research has shown that the CamAPS ' +
        '       FX app helps people feel less burdened by their diabetes and more able to ' +
        '       lead flexible and spontaneous lives. ' +
        '</p> ' +
        '<p> ' +
        '        Individuals also credited the app for acting as a safety net and having a ' +
        '       level of responsiveness which extended beyond their own capabilities. ' +
        '       Although users are still able to override the app should they wish to ease off or ' +
        '       boost therapy because of physiological demands such as exercise or illness.' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “It is amazing how much treatment has changed since I was diagnosed, ' +
        '       I really feel like I’ve come from the desert into the digital world. To anyone ' +
        '       considering the CamAPS FX app my advice is quite simple, go for it. It really is ' +
        '       transformational and if I can do it anyone can.” ' +
        '    </i> ' +
        '</p>'

};
/**
 * Texts for Amanda McLaren's review (list, home slider, and detail article)
 */
export const amandaReviewText = {
    title: 'Amanda McLaren - CamAPS FX',
    titleMeta: 'Read Amanda McLaren\'s review of CamAPS FX in New Zealand',
    descriptionMeta: 'Amanda McLaren shares how CamAPS FX with her YpsoPump and FreeStyle Libre 3+, ' +
        'publicly funded in New Zealand in 2024, has meant fewer hypos, steadier blood sugar, a lower HbA1c and more peace of mind after 55 years with type 1 diabetes.',
    keywords:
        'camaps review Amanda McLaren, camaps fx review Amanda McLaren, ' +
        '',
    localeMeta: 'en_gb',

    imageTitle: 'Amanda McLaren',
    shortIntroAndBody:
        '<h2>Less time injecting is liberating.</h2>' +
        '<p>' +
        '    At 60 years old, Amanda McLaren has lived with type 1 diabetes for 55 years. ' +
        '    She began using CamAPS FX in October 2024, with her YpsoPump and ' +
        '    FreeStyle Libre 3+, when it became publicly funded in New Zealand. ' +
        '    Since then, she has experienced fewer hypos and a much more manageable daily routine.' +
        '</p>',
    body:
        '<h2>Less time injecting is liberating.</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    At 60 years old, Amanda McLaren has lived with type 1 diabetes for 55 years. She began using ' +
        '    CamAPS FX in October 2024, with her YpsoPump and FreeStyle Libre 3+, when it became publicly funded ' +
        '    in New Zealand. Since then, she has experienced fewer hypos and a much more manageable daily routine. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Diagnosed on 13 April 1972, the early years of managing her type 1 diabetes were mostly guesswork, and ' +
        '    even with home blood glucose monitoring, constant finger pricks made them sore and overcorrecting or ' +
        '    under bolusing was common. Using FreeStyle Libre 2 helped, but injecting up to 10 times a day was ' +
        '    time consuming and often tricky. ' +
        '</p> ' +
        '<p> ' +
        '    Amanda also faced nocturnal hypos and the dawn phenomenon, which affected her sleep and made mornings exhausting. ' +
        '    Finding a better way to manage her condition was crucial for her mental and physical wellbeing, and to ' +
        '    reduce the risk of complications. ' +
        '</p> ' +
        '<p> ' +
        '    Starting with CamAPS FX was straightforward, with Amanda saying: ' +
        '    <i>“I had a great team helping me and found it easy.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    The app has taken a lot of decision-making away, with constant basal adjustments keeping her blood sugar ' +
        '    levels steadier. She explained: ' +
        '    <i>“Far less intervention is required. Apart from entering meals, I basically don\'t have to worry anymore.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Since starting CamAPS FX, Amanda\'s HbA1c is lower, her blood sugar swings are fewer, the dawn phenomenon ' +
        '    has disappeared and nocturnal hypos happen far less often. Not having to micromanage every detail of her ' +
        '    type 1 diabetes has been a huge relief. ' +
        '</p> ' +
        '<p> ' +
        '    Amanda noted: ' +
        '    <i>“Less time injecting is liberating. Better control gives me more peace of mind.”</i> She now spends ' +
        '    much less time worrying about highs and lows, giving her more freedom and confidence in her daily life. ' +
        '</p> ' +
        '<p> ' +
        '    Reflecting on her user experience, Amanda concluded: ' +
        '    <i>“After an initial settling in period while the app ‘learnt’ about me, and me learning to trust it to ' +
        '    manage my condition, so much worry and decision making has been taken away. It\'s easy to use and has been ' +
        '    a life changer for me.”</i> ' +
        '</p>',
};


/**
 * Texts for Christopher Salter's review (list, home slider, and detail article)
 */
export const christopherReviewText = {
    title: 'Christopher Salter - CamAPS FX',
    titleMeta: 'Read Christopher Salter\'s review of CamAPS FX',
    descriptionMeta: 'Christopher Salter shares how CamAPS FX with his YpsoPump and FreeStyle Libre 3 Plus has improved time in range, HbA1c and daily life after more than three decades with type 1 diabetes.',
    keywords:
        'camaps review Christopher Salter, camaps fx review Christopher Salter, ' +
        '',
    localeMeta: 'en_gb',

    imageTitle: 'Christopher Salter',
    shortIntroAndBody:
        '<h2>This is what I can imagine being a non-diabetic would feel close to</h2>' +
        '<p>' +
        '    For Christopher Salter, living with type 1 diabetes has been a lifelong experience, shaping much of his day-to-day life since his diagnosis at just two-years-old. Now 36, he has spent more than three decades navigating the challenges of a condition that was often unpredictable and demanding.' +
        '</p>',
    body:
        '<h2>This is what I can imagine being a non-diabetic would feel close to</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    For Christopher Salter, living with type 1 diabetes has been a lifelong experience, shaping much of his day-to-day life since his diagnosis at just two-years-old. Now 36, he has spent more than three decades navigating the challenges of a condition that was often unpredictable and demanding. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    His glucose levels were frequently difficult to stabilise, and regular hypoglycaemic episodes made daily life both stressful and exhausting. Before using advanced technology, Chris describes his type 1 diabetes management as <i>“very stressful and time consuming,”</i> with much of his energy focused on preventing and treating hypos. ' +
        '</p> ' +
        '<p> ' +
        '    These challenges extended beyond physical health. During school, episodes were often handled in front of peers, making him feel exposed, while in later years he found it difficult to explain his condition to others, which affected his relationships and confidence. Over time, the constant pressure led to burnout and a growing sense of disengagement from his type 1 diabetes care. ' +
        '</p> ' +
        '<p> ' +
        '    After completing a DAFNE course, Chris\' diabetes specialist nurse recommended CamAPS FX as a way to ease the burden of daily management. He started using the system around three years ago, alongside the YpsoPump and FreeStyle Libre 3 Plus. Although accessing funding required patience, he found the training and setup process smooth once everything was in place. ' +
        '</p> ' +
        '<p> ' +
        '    The impact has been significant. Since starting CamAPS FX, Chris has seen notable improvements in his time in range, HbA1c and overall glucose stability. Hypoglycaemic episodes – particularly overnight and at work – have reduced considerably, and his sleep quality has improved as a result. ' +
        '</p> ' +
        '<p> ' +
        '    Most importantly, the system has changed how he feels day to day. With less need for constant decision-making, he feels more relaxed and in control, and the mental load of managing type 1 diabetes has reduced. Chris said: <i>“Using CamAPS FX has been the closest thing to date to being a non-diabetic as this is what I can imagine being a non-diabetic would feel close to.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Chris continues to use CamAPS FX and views it as an essential part of his long-term care. He would readily recommend it to others, citing not only the clinical improvements but the renewed sense of normality and confidence it has brought to his life. ' +
        '</p>',
};


/**
 * Texts for Alice Hibbert-Davies review article
 */
export const aliceReviewText = {
    title: 'Alice Hibbert-Davies - CamAPS FX',
    titleMeta: 'Read Alice Hibbert-Davies\' review of CamAPS FX',
    descriptionMeta: 'Alice Hibbert-Davies shares how the myLoop system with CamAPS FX transformed her type 1 diabetes ' +
        'management and helped her conquer Mount Kilimanjaro.',
    keywords:
        'camaps review Alice Hibbert-Davies, camaps fx review Alice Hibbert-Davies, myLoop CamAPS FX, ' +
        '',
    localeMeta: 'en_gb',

    imageTitle: 'Alice Hibbert-Davies',
    shortIntroAndBody:
        '<h2>From managing T1D to conquering Mount Kilimanjaro.</h2>' +
        '<p>' +
        '    Alice Hibbert-Davies is reaching new heights with the help of the myLoop system with CamAPS FX, which she ' +
        '    credits with transforming her diabetes management and giving her greater freedom to embrace life\'s ' +
        '    biggest adventures.' +
        '</p>',
    body:
        '<h2>From managing type 1 diabetes to conquering the summit of Mount Kilimanjaro.</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    Alice Hibbert-Davies is reaching new heights with the help of the myLoop system with CamAPS FX, which she ' +
        '    credits with transforming her diabetes management and giving her greater freedom to embrace life\'s ' +
        '    biggest adventures. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Alice was diagnosed with type 1 diabetes when she was 18 after experiencing symptoms including increased ' +
        '    thirst, weight loss and passing urine more frequently. She was already familiar with the condition as her ' +
        '    younger sister had been diagnosed with type 1 diabetes a few years earlier at the age of 13. ' +
        '</p> ' +
        '<p> ' +
        '    Alice quickly contacted her doctor with the suspicion she had type 1 diabetes but despite her prior ' +
        '    knowledge and experience of the condition, she said it still came as a shock when she was diagnosed. ' +
        '</p> ' +
        '<p> ' +
        '    Alice said: ' +
        '    <i>“Even though I thought I had type 1 diabetes, when I was told I still thought, ‘Oh my gosh, why has ' +
        '    this happened to me?’</i> ' +
        '</p> ' +
        '<p> ' +
        '    <i>“It was still a massive shock and difficult to take in all the information – I found it overwhelming.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Alice was in her first year of studying for a degree in wildlife conservation but was living at home, ' +
        '    which she said made it a little easier for her to navigate the early days following her diagnosis. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“To begin with, it was a massive change to how I live and trying to work out how managing my diabetes ' +
        '    would fit into my life – all the decision making and checking my levels,”</i> Alice said. ' +
        '</p> ' +
        '<p> ' +
        '    For the first year following her diagnosis, Alice manually injected insulin but jumped at the chance of ' +
        '    using a closed-loop system when it was offered to her. ' +
        '</p> ' +
        '<p> ' +
        '    Alice, who is 22 and lives in Bath, said opting for the closed loop system was ' +
        '    <i>“one of the best decisions I have ever made”</i>. ' +
        '</p> ' +
        '<p> ' +
        '    She said: ' +
        '    <i>“I was drawn to the YpsoPump with CamAPS FX because of the flexibility it gives me. I’d heard from ' +
        '    other people how much easier it made managing their condition. The main draw was the pre-filled insulin ' +
        '    vials and how it is approved for use in pregnancy, which is good to know for the future.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    A part-time gymnastics coach and regular hiker, Alice said she is grateful for CamAPS for allowing her ' +
        '    to continue to pursue an active lifestyle. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“CamAPS is very straightforward to use in terms of inputting things like carbs and hypo snacks,”</i> ' +
        '    she said. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“I’m always impressed by it. I have a very busy lifestyle and my daily routine is different every day ' +
        '    of the week, but it always manages to keep my level in range, even when I’m waking up at different times ' +
        '    and eating meals at different times of the day.</i> ' +
        '</p> ' +
        '<p> ' +
        '    <i>“It’s that peace of mind, knowing it’s working and keeping me in range. It just takes away some of ' +
        '    the extra stress of having diabetes.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Alice, who is currently studying for a PhD in herpetology, the study of reptiles and amphibians, climbed ' +
        '    Mount Kilimanjaro in September 2026, using the challenge to raise awareness of type 1 diabetes and inspire ' +
        '    others who have been diagnosed. ' +
        '</p> ' +
        '<p> ' +
        '    She said: ' +
        '    <i>“Having type 1 diabetes doesn’t have to stop you. You can still live the life you want.”</i> ' +
        '</p>',
};
